import { connect } from 'react-redux';
import { addIntegrationRequest, removeIntegrationRequest } from '../actions';
import {
    getVisibleIntegrationRequests,
    getHiddenRequestsByType,
    getIntegrationRequestsError,
    getIntegrationRequestsLoaded,
    getIntegrationRequestsLoading,
} from '../../selectors/partnerIntegration';
import { getAdminModeEnabled } from '../../selectors/user';
import IntegrationHomepage from '../components/IntegrationHomepage';

const mapStateToProps = state => ({
    requests: getVisibleIntegrationRequests(state),
    hiddenByType: getHiddenRequestsByType(state),
    loading: getIntegrationRequestsLoading(state),
    loaded: getIntegrationRequestsLoaded(state),
    error: getIntegrationRequestsError(state),
});

const mapDispatchToProps = dispatch => ({
    onAddRequest: request => dispatch(addIntegrationRequest(request)),
    onRemoveRequest: requestId => dispatch(removeIntegrationRequest(requestId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationHomepage);
